import { createContext, useContext } from 'react';

// Outside their providers (leaf and page tests): nothing to offer
export const InstallAppContext = createContext({
  platform: 'none',
  standalone: false,
  canOffer: false,
  dismissedAt: null,
  tapped: false,
  install: () => undefined,
  dismissBanner: () => undefined,
});

export const useInstallApp = () => useContext(InstallAppContext);

export const PushContext = createContext({
  available: false,
  permission: 'default',
  subscribed: false,
  openOptIn: () => undefined,
  disable: async () => undefined,
});

export const usePush = () => useContext(PushContext);
